export const searchResults = (
  data,
) => {
  if (data.length > 0) {
    return data;
  }

  return [];
};
